import { useEffect, useState } from 'react';
import { getPublicCatalog, getPublicPosts } from '../../lib/api';
import { siteIdentity } from '../../content/siteContent';
import { CuratedPage } from './CuratedPage';
import { CatalogGrid } from '../components/CatalogGrid';
import { PostList } from '../components/PostList';
import type { CatalogItem, CustomPage } from '../../lib/types';

export function HomePage() {
  const [items, setItems] = useState<CatalogItem[]>([]);
  const [posts, setPosts] = useState<CustomPage[]>([]);

  useEffect(() => {
    getPublicCatalog().then((all) => setItems(all.slice(0, 3))).catch(() => setItems([]));
  }, []);

  useEffect(() => {
    getPublicPosts().then((all) => setPosts(all.slice(0, 3))).catch(() => setPosts([]));
  }, []);

  return (
    <>
      <CuratedPage slug="home" />

      <section className="catalog-teaser">
        <header className="section-heading">
          <h2>{siteIdentity.catalogLabel}</h2>
          <a className="text-link" href={siteIdentity.catalogPath}>View all</a>
        </header>
        <CatalogGrid items={items} />
      </section>

      <section className="blog-teaser">
        <header className="section-heading">
          <h2>From the blog</h2>
          <a className="text-link" href="/blog">View all</a>
        </header>
        <PostList posts={posts} />
      </section>

      <section className="contact-cta">
        <p className="eyebrow">Visit us</p>
        <h2>Have a question about our {siteIdentity.catalogLabel.toLowerCase()}?</h2>
        <a className="button" href="/contact">Get in touch</a>
      </section>
    </>
  );
}
